import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const getGraphicBlanks = {
  name: "getGraphicBlanks" as const,
  input: z.object({}),
  output: z.object({
    products: z.array(
      z.object({
        productId: productIdFormat.schema,
        title: z.string(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
        barcodes: z.array(z.string()),
      }),
    ),
  }),
};
